import { CurrentAddress } from '../../client/appTypings';
import { Dispatch } from '../../client/configureStore';
import { getGeoLocation } from '../../service/locationApi';
import { geoLocationFetchSuccessAction } from './actions';
import { YleApiCredentials } from 'src/common/types';

export const fetchGeoLocationThunk =
  (authenticationKeys?: YleApiCredentials) => async (dispatch: Dispatch) => {
    if (!authenticationKeys) throw new Error('no authFetch');

    const geoLocation: CurrentAddress =
      await getGeoLocation(authenticationKeys);

    dispatch(geoLocationFetchSuccessAction(geoLocation));
    return geoLocation;
  };
